import { removeClocktowerFootprint, tileMayContainClocktower } from './clocktower-footprint.js';
import { removeBusShelterFootprint, tileMayContainBusShelter } from './bus-shelter-footprint.js';

export const BUILDING_PATCH_PROTOCOL = 'clocktower-tile';

function tileCoordinates(url) {
  // transformRequest ser ALLE fliseforespørsler, også terrengets egne
  // PNG-er, og de ligger på en relativ adresse (/terrain/z/x/y.png).
  // `new URL()` kaster på relative adresser, så den må ha en base – ellers
  // dør hele transformRequest og kartet mister flisene sine.
  let parsed;
  try {
    parsed = new URL(url, typeof location === 'undefined' ? undefined : location.href);
  } catch {
    return null;
  }
  if (parsed.origin !== 'https://tiles.openfreemap.org') return null;
  const match = parsed.pathname.match(/^\/planet\/[^/]+\/(\d+)\/(\d+)\/(\d+)\.pbf$/);
  return match ? { z: Number(match[1]), x: Number(match[2]), y: Number(match[3]) } : null;
}

// True if the tile contains any building footprint we replace with a 3D model.
function tileNeedsPatch(tile) {
  return tileMayContainClocktower(tile) || tileMayContainBusShelter(tile);
}

// Keep TileJSON, glyphs and all unrelated vector requests on the normal path.
export function transformBuildingTileRequest(url, resourceType) {
  const tile = resourceType === 'Tile' ? tileCoordinates(url) : null;
  return { url: tile && tileNeedsPatch(tile) ? `${BUILDING_PATCH_PROTOCOL}://${url}` : url };
}

export async function loadBuildingTile(params, abortController) {
  const url = params.url.slice(`${BUILDING_PATCH_PROTOCOL}://`.length);
  const tile = tileCoordinates(url);
  if (!tile) throw new Error('Invalid building patch tile URL');
  const response = await fetch(url, {
    signal: abortController.signal,
    headers: params.headers,
    credentials: params.credentials,
  });
  if (!response.ok) throw new Error(`Building tile request failed: ${response.status}`);
  // Apply both footprint removers; each is a no-op on tiles it does not target.
  let buffer = await response.arrayBuffer();
  buffer = removeClocktowerFootprint(buffer, tile).data;
  buffer = removeBusShelterFootprint(buffer, tile).data;
  return {
    data: buffer,
    cacheControl: response.headers.get('Cache-Control') ?? undefined,
    expires: response.headers.get('Expires') ?? undefined,
  };
}
